import { Slot } from "radix-ui";
import type { HTMLAttributes, Ref } from "react";

export interface PlateProps extends HTMLAttributes<HTMLDivElement> {
  /** Катет среза 45°: sm плитка, md карточка скана, lg лист формы. false без среза. */
  cut?: "sm" | "md" | "lg" | false;
  /** Рамка 2 px, срез обведён. */
  bordered?: boolean;
  /**
   * Плашка во всю ширину телефона: там срез снимается, вокруг нет фона
   * (docs/ui-rules.md, «11»).
   */
  bleed?: boolean;
  asChild?: boolean;
  ref?: Ref<HTMLDivElement>;
}

/** Информационная плашка Д2: белая на сером, прямые углы, срез справа сверху. */
export function Plate({ cut = "sm", bordered, bleed, asChild, className, ...rest }: PlateProps) {
  const Comp = asChild ? Slot.Root : "div";
  const classes = ["w-plate", cut ? "w-cut" : "", className ?? ""].filter(Boolean).join(" ");
  return (
    <Comp
      className={classes}
      data-cut-size={cut && cut !== "sm" ? cut : undefined}
      data-cut-line={cut && bordered ? "" : undefined}
      data-cut-bleed={bleed ? "" : undefined}
      data-bordered={bordered ? "" : undefined}
      {...rest}
    />
  );
}
